import { RegisterCard } from "../../components/RegisterCard";
import { MediaUploadInput } from "../../components/MediaUploadInput";
import { CircleLoader } from "../../components/CircleLoader";
import { Smile, Zap, Camera, Send } from "lucide-react";

export const CAattitude = ({
  formData,
  onFormChange,
  onFormSubmit,
  loading,
}: any) => {
  const moods = [
    "Happy",
    "Excited",
    "Good",
    "Indifferent",
    "Sad",
    "Cranky",
    "Gloomy",
  ];

  return (
    <div className="w-full max-w-4xl mx-auto p-4">
      <RegisterCard
        title="Mood & Morale"
        details="How is the child feeling right now?"
      />

      <form
        onSubmit={onFormSubmit}
        className="mt-6 bg-white rounded-[2.5rem] border border-slate-100 shadow-xl overflow-hidden flex flex-col lg:flex-row"
      >
        <div className="flex-1 p-8 space-y-8 order-2 lg:order-1">
          <div className="space-y-3">
            <label className="flex items-center gap-2 text-xs font-black text-slate-500 uppercase tracking-widest ml-1">
              <Smile size={14} className="text-yellow-500" /> Current Mood
            </label>
            <div className="flex flex-wrap gap-2">
              {moods.map((m) => (
                <button
                  key={m}
                  type="button"
                  onClick={() => onFormChange("mood", m.toLowerCase())}
                  className={`px-4 py-2 rounded-xl font-bold text-sm transition-all border-2
                  ${formData["mood"] === m.toLowerCase() ? "bg-yellow-400 border-yellow-400 text-slate-900" : "bg-slate-50 border-transparent text-slate-400"}`}
                >
                  {m}
                </button>
              ))}
            </div>
          </div>

          <div className="space-y-3">
            <label className="flex items-center gap-2 text-xs font-black text-slate-500 uppercase tracking-widest ml-1">
              <Zap size={14} className="text-blue-500" /> Morale Level
            </label>
            <div className="flex bg-slate-100 p-1 rounded-xl max-w-xs">
              {["Low", "Little", "High"].map((level) => (
                <button
                  key={level}
                  type="button"
                  onClick={() => onFormChange("morale", level.toLowerCase())}
                  className={`flex-1 py-2 rounded-lg font-bold text-xs transition-all ${formData["morale"] === level.toLowerCase() ? "bg-white text-blue-600 shadow-sm" : "text-slate-400"}`}
                >
                  {level}
                </button>
              ))}
            </div>
          </div>

          <div className="space-y-3">
            <label className="flex items-center gap-2 text-xs font-black text-slate-500 uppercase tracking-widest ml-1">
              <Camera size={14} /> Attachment
            </label>
            <div className="p-4 bg-slate-50 border-2 border-dashed border-slate-200 rounded-2xl">
              <MediaUploadInput
                singleOption={false}
                onChangeFn={(e: any, type: any) =>
                  onFormChange(
                    type === "video" ? "video" : "image",
                    e && type === "video"
                      ? e.target.files[0]
                      : e && type === "image"
                        ? e.target.files
                        : "",
                  )
                }
                pdfNull={true}
              />
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full h-16 bg-slate-900 text-white rounded-2xl font-black uppercase tracking-widest transition-all"
          >
            {loading ? <CircleLoader /> : "Update Mood"}
          </button>
        </div>

        <div className="lg:w-64 bg-slate-50 flex items-center justify-center p-8 order-1 lg:order-2">
          <img
            src="/img/attitude.svg"
            className="w-40 h-40 animate-float"
            alt="mood"
          />
        </div>
      </form>
    </div>
  );
};
